import React from "react";

import { DataContext } from "../../types/common";
import { BesuProjectState, ProjectStatus } from "../../types/project";
import { emptyPromise } from "../../utils/common";

const ProjectContext = React.createContext<DataContext<BesuProjectState>>({
    data: {
        referenceId: "",
        externalProjectId: "",
        name: "",
        status: ProjectStatus.CREATED,
        createdAt: "",
        updatedAt: "",
        developer: {
            accountName: "",
            displayName: "",
            wallet: "",
        },
        mainContractors: [],
        architect: null,
        claimIds: [],
        claimReferenceIds: [],
        claimsByContractor: [],
        claimCountByContractorList: [],
        bankAccountRefs: [],
        claimApprovers: [],
        paymentOrderApprovers: [],
        claimStatuses: [],
    },
    mutate: emptyPromise,
});

export default ProjectContext;
